import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import _ from 'lodash';
import Subnav from '../subnav';
import moment from 'moment';
import Button from '../form/Button';
import { history } from '../../state/store';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import Message from '../form/Message';
import ActivityLog from '../../api/activity';
import CSVButton from './CSVDownloadButton';

let debounce;

class ActivityLogs extends Component {
    constructor(props, context) {
        super(props, context);

        // See if there is an organization id passed.
        const { id } = this.props.match.params;
        const parsedId = parseInt(id, 10) || null;

        this.state = {
            members: [],
            organizations: [],
            organizationId: parsedId,
            practices: [],
            criteria_id: [],
            loading: true,
            message: '',
            logs: [],
            csv: null,
            csvLoading: 0,
            filters: {},
            stats: [],
            pages: null,
            totalLogs: 0,
            appliedDates: {
                selection: {
                    startDate: null,
                    endDate: null,
                    key: 'selection',
                },
            },
            dateRangePicker: {
                selection: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                },
                compare: {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'compare',
                },
            },
        };
    }

    fetchData = (state = null, instance, newDates = this.state.appliedDates) => {
        clearTimeout(debounce);
        debounce = setTimeout(
            function() {
                this.fetchDataDebounced(state, instance, newDates);
            }.bind(this),
            800
        );
    };

    fetchDataCSV = async () => {
        this.setState({ csvLoading: 1 }, async () => {
            const { filters, appliedDates } = this.state;

            let filtersNew = _.cloneDeep(filters);
            filtersNew.pageSize = 10000000000000; // Set high so it gets back all results
            filtersNew.page = 0;
            const newDates = appliedDates;
            _.remove(filtersNew.filtered, function(n) {
                return n.id === 'created_at';
            });
            filtersNew.filtered.push({
                id: 'created_at',
                value: {
                    start: newDates.selection.startDate,
                    end: newDates.selection.endDate,
                },
            });
            const data = await ActivityLog.fetchLogs(filtersNew);
            this.setState({ csv: data[0], csvLoading: 2 });
        });
    };

    fetchDataDebounced = (state = null, instance, newDates = this.state.appliedDates) => {
        this.setState({ loading: true, csvLoading: 0, csv: null });
        let filters;
        if (state === null) {
            filters = this.state.filters;
        } else {
            let { page, pageSize, sorted, filtered } = state;
            const { organizationId } = this.state;
            filters = { page, pageSize, sorted, filtered, site: 'INITIAL', organizationId };

            this.setState({ filters });
        }
        _.remove(filters.filtered, function(n) {
            return n.id === 'created_at';
        });
        filters.filtered.push({
            id: 'created_at',
            value: {
                start: newDates.selection.startDate,
                end: newDates.selection.endDate,
            },
        });
        ActivityLog.fetchLogs(filters)
            .then(items => {
                this.setState({ logs: items[0], stats: items[1], loading: false, totalLogs: items[2], pages: Math.ceil(items[2] / filters.pageSize) });
            })
            .catch(errorMessage => {
                console.log('Error: ' + errorMessage);
            });
    };

    handleRangeChange(which, payload) {
        this.setState({
            dateRangePicker: {
                ...this.state.dateRangePicker,
                ...payload,
            },
        });
    }

    applyDates = () => {
        const { selection } = this.state.dateRangePicker;
        const appliedDates = {
            selection: {
                startDate: selection.startDate.toISOString(),
                endDate: selection.endDate.toISOString(),
                key: 'selection',
            },
        };
        this.setState({ appliedDates });
        this.fetchData(null, null, appliedDates);
    };

    clearDates = () => {
        const appliedDates = {
            selection: {
                startDate: null,
                endDate: null,
                key: 'selection',
            },
        };
        this.setState({ appliedDates });
        this.fetchData(null, null, appliedDates);
    };

    getStats = () => {
        return this.state.stats.map(function(items) {
            return (
                <li key={items.concept_code}>
                    <i class="fa fa-check-circle"></i>
                    {items.code_count} {items.concept_code}
                </li>
            );
        });
    };

    render() {
        const { logs, pages, loading } = this.state;

        if (this.state.isLoading || !_.has(this.state, 'logs')) {
            return (
                <div className="page">
                    <div className="page__subnav">
                        <Subnav />
                    </div>
                    <div className="page__body">
                        <i className="fa fa-circle-o-notch m2spin" />
                        Loading Organizations...
                    </div>
                </div>
            );
        }

        return (
            <div className="page ActivityLogsPage">
                <div className="page__subnav">
                    <Subnav filterId={this.state.organizationId} />
                </div>
                <div className="page__header">
                    <div class="OrganizationHeaderMetrics ActivityLogHeader">
                        <div class="info">
                            <h2>
                                <i class="fa fa-sitemap"></i> Activity Logs
                            </h2>
                        </div>
                        <div class="OrganizationMetrics">
                            <div class="NextCheckinMetrics">
                                <p class="header">
                                    Dates Filtered{' '}
                                    <span class="subheader">
                                        {this.state.appliedDates.selection.startDate !== null
                                            ? `From ${moment(this.state.appliedDates.selection.startDate).format('MMMM Do YYYY')} To ${moment(this.state.appliedDates.selection.endDate).format('MMMM Do YYYY')}`
                                            : 'No Dates Filtered'}
                                    </span>
                                </p>
                            </div>
                            <div class="NextCheckinInProgress">
                                <div class="PlanMetrics">
                                    <div class="ProjectPlan">
                                        <p class="header">Stats</p>
                                        <ul>
                                            <li>
                                                <i class="fa fa-check-circle"></i>
                                                {this.state.totalLogs} Total Results
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="Counts">
                                        <p class="header">Concept Counts</p>
                                        <ul>{this.getStats()}</ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="full-width">
                    <div className="sidebarpage">
                        <div className="sidebarpage__content">
                            <div className="table-wrapper">
                                <Message info={this.state.message} />
                                <ReactTable
                                    data={logs}
                                    pages={pages}
                                    loading={loading}
                                    onFetchData={this.fetchData}
                                    filterable
                                    columns={[
                                        {
                                            Header: 'Organization',
                                            accessor: 'org_name',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                        },
                                        {
                                            Header: 'Practice',
                                            accessor: 'practice_name',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                        },
                                        {
                                            Header: 'Concept',
                                            accessor: 'concept_code',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                        },
                                        {
                                            Header: 'Code',
                                            accessor: 'criteria_code',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                        },
                                        {
                                            Header: 'Action',
                                            accessor: 'action',
                                            id: 'action',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                            filterMethod: (filter, row) => {
                                                if (filter.value === '') {
                                                    return true;
                                                }
                                                return row[filter.id] === filter.value;
                                            },
                                            Filter: ({ filter, onChange }) => {
                                                return (
                                                    <select onChange={event => onChange(event.target.value)} style={{ width: '100%' }} value={filter ? filter.value : ''}>
                                                        <option value=" ">All</option>
                                                        <option value="Created">Created</option>
                                                        <option value="Revised">Revised</option>
                                                        <option value="Removed">Removed</option>
                                                    </select>
                                                );
                                            },
                                        },
                                        {
                                            Header: 'Log',
                                            accessor: 'value',
                                            class: 'log',
                                            Cell: props => (
                                                <div
                                                    className="tooltipContainer"
                                                    onClick={() => {
                                                        history.push(`/criterion/${props.original.criteria_id}`);
                                                    }}>
                                                    {props.value}
                                                    <div className="tooltip right">
                                                        <div className="tooltip-arrow" />
                                                        <div className="tooltip-label">{props.value}</div>
                                                    </div>
                                                </div>
                                            ),
                                        },
                                        {
                                            Header: 'Email',
                                            accessor: 'user_id',
                                            Cell: row => <div className={'center-column'}>{row.value}</div>,
                                        },
                                        {
                                            Header: 'Date',
                                            accessor: 'created_at',
                                            filterable: false,
                                            sortable: false,
                                            Cell: ({ row }) => (row.created_at ? moment(row.created_at).format('MM/DD/YYYY') : ''),
                                        },
                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    manual
                                />
                            </div>
                        </div>
                        <div className="sidebarpage__sidebar">
                            <div className="CsvContainer">
                                <CSVButton data={this.state.csv} fetchCSVData={this.fetchDataCSV} loading={this.state.csvLoading} />
                            </div>

                            <DateRangePicker
                                onChange={this.handleRangeChange.bind(this, 'item')}
                                format={'MMMM Do YYYY'}
                                direction={'vertical'}
                                className={'TheDateRange'}
                                scroll={{ enabled: true }}
                                showDateDisplay={false}
                                ranges={[this.state.dateRangePicker.selection]}
                                minDate={new Date('August 16 2019')}
                            />
                            <div className="ButtonGroup">
                                <div className="SaveButton">
                                    <Button defaultText="Apply Dates" busyText="Saving..." onClick={this.applyDates} />
                                </div>
                                <div className="SaveButton">
                                    <Button defaultText="Clear Dates" busyText="Saving..." onClick={this.clearDates} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ActivityLogs;
